import {object, ObjectSchema, string} from "yup";
import {TFunction} from "i18next";
import {formError} from "../../shared/components/forms/formUtils";

const PERSON_NAME_PATTERN = /^[^<>&"\v$%!#?§;*~\/\\|^=\[\]{}()\p{Cc}]+$/u;
import { ValidityInfo, validityInfoSchema } from "../../shared/technical/domain/ValidityInfo";

export interface Company {
  id?: string,
  name: string,
  city?: string,
  customerNumber?: string,
  logoFileId?: string,
  logoUrl?: string,
  street?: string,
  country?: string,
  postalCode?: string,
  systemOfMeasurement?: string,
  currency?: string,
  contactPerson?: ContactPerson,
  validityInfo?: ValidityInfo
}

export enum SystemOfMeasurement {
  'METRIC' = 'METRIC',
  'IMPERIAL' = 'IMPERIAL',
}

export const SYSTEM_OF_MEASUREMENTS = Object.values(SystemOfMeasurement);

export enum Currency {
  'EUR' = 'EUR',
  'USD' = 'USD',
  'GBP' = 'GBP',
}

export const CURRENCIES = Object.values(Currency);

export interface ContactPerson {
  title?: string,
  firstName?: string,
  lastName?: string,
  email?: string,
  phone?: string,
  position?: string
}

export function companySchema(t: TFunction): ObjectSchema<Company> {
  return object({
    id: string(),
    name: string().required(fieldDefinedError(t)),
    city: string(),
    customerNumber: string(),
    logoFileId: string(),
    logoUrl: string(),
    street: string(),
    country: string(),
    postalCode: string(),
    systemOfMeasurement: string().oneOf(SYSTEM_OF_MEASUREMENTS),
    currency: string().oneOf(CURRENCIES),
    contactPerson: contactPersonSchema(t),
    validityInfo: validityInfoSchema(t)
  })
}

export function contactPersonSchema(t: TFunction): ObjectSchema<ContactPerson> {
  return object({
    title: string(),
    firstName: string().matches(PERSON_NAME_PATTERN, {message: formError(t, 'containsProhibitedCharacters', 'User.') as any, excludeEmptyString: true}),
    lastName: string().matches(PERSON_NAME_PATTERN, {message: formError(t, 'containsProhibitedCharacters', 'User.') as any, excludeEmptyString: true}),
    email: string(),
    phone: string(),
    position: string()
  })
}

function fieldDefinedError(t: TFunction) {
  return formError(t, 'mustBeDefined', 'Company.');
}

export function defaultCompany(t: TFunction) {
  return companySchema(t).getDefault() as Company
}
